<template>
  <header class="rec-header">
    <v-row class="ma-0 px-6" align="center" justify="space-between">
      <v-col cols="auto" class="px-0 py-5 col-md-3">
        <div @click="goAnnouncementPage">
          <v-img
            position="left"
            alt="Vuetify Logo"
            class="shrink"
            contain
            :src="logo"
            transition="scale-transition"
            height="20"
            style="cursor: pointer;"
          >
          </v-img>
        </div>
      </v-col>
      <v-col cols="auto" class="pa-0">
        <!-- <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <i-btn
              v-bind="attrs"
              v-on="on"
              elevation="0"
              class="d-fled align-center"
              icon
            >
               <v-icon color="rgba(0, 0, 0, 0.54)">mdi-translate</v-icon> -->

        <!-- <i class="material-icons-outlined">
                translate
              </i>
            </i-btn>
          </template>
          <v-list nav dense width="120">
            <v-list-item-group v-model="$i18n.locale" color="primary">
              <v-list-item
                v-for="(item, index) in [
                  {
                    text: '한국어',
                    value: 'ko',
                  },
                  {
                    text: 'English',
                    value: 'en',
                  },
                  {
                    text: '日本語',
                    value: 'jp',
                  },
                ]"
                :key="index"
                :value="item.value"
              >
                <v-list-item-content>
                  <v-list-item-title style="font-size:0.8rem">{{
                    item.text
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu> -->

        <i-btn
          icon
          class="ml-2"
          v-if="this.$store.getters.isLogin"
          @click="logout"
        >
          <i class="material-icons-outlined">
            logout
          </i>
        </i-btn>
      </v-col>
    </v-row>
  </header>
</template>

<script>
import { getAuthJson, getJson } from '@/api/network';
export default {
  name: 'RecHeader',
  data() {
    return {
      annoListUrl: '',
      logo: '',
      tenantKey: '',
    };
  },
  created() {
    this.tenantKey = this.$route.params.tenantKey;
    this.setLogo();
  },
  mounted() {
    this.getApplyList();
  },
  methods: {
    goAnnouncementPage() {
      window.open(this.annoListUrl, '_blank');
    },
    getApplyList() {
      getAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/apply/list',
        {},
      ).then(res => {
        if (res.status == 200) {
          this.annoListUrl = res.data.annoListUrl;
        }
      });
    },

    logout() {
      try {
        getAuthJson(
          process.env.VUE_APP_API_URL + 'api/v1/' + this.tenantKey + '/logout',
        ).then(res => {
          console.log(res);
          this.$store.commit('logout');
          this.$router.push({ name: 'login' });
        });
      } catch (error) {
        console.log('error');
        this.$store.commit('logout');
        this.$router.push({ name: 'login' });
      }
    },
    console() {
      // this.$router.push('/console/' + this.tenantKey);
    },
    setLogo: function() {
      this.logo = ''; //require(`@/img/login/logo_header_${this.$route.params.tenantKey}.png`);
      getJson('api/' + this.$route.params.tenantKey + '/image/logo', {})
        .then(res => {
          if (
            res &&
            res.data &&
            res.data.hasOwnProperty('image') &&
            res.data.image &&
            res.data.image != ''
          ) {
            this.logo = res.data.image;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.rec-header .material-icons-outlined {
  font-size: 24px !important;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 8px 16px !important;
}
</style>
